import { useEffect, useRef } from "react";

import { FileUpload, FileUploadProps } from "./FileUpload";
import {
  DocumentCreateParams,
  DocumentCreateResponse,
  S3FileInfo,
} from "./types";
import { fileToFileInfo } from "./utils";
import { useAPIRequest } from "../../../legacy-api";

export interface FileUploadS3Props extends Omit<FileUploadProps, "onSelected"> {
  requestUrl: string;
  requestPayload?: Record<string, string | null | undefined>;
  files: S3FileInfo[];
  setFiles(files: S3FileInfo[]): void;
}

export function FileUploadS3(props: FileUploadS3Props) {
  const {
    requestUrl,
    requestPayload = {},
    files,
    setFiles,
    ...fileUploadProps
  } = props;

  const request = useAPIRequest();

  async function getUploadUrl(params: DocumentCreateParams) {
    const response = await request<DocumentCreateResponse>(requestUrl, {
      method: "POST",
      body: JSON.stringify({ ...params, ...requestPayload }),
    });

    return response;
  }

  const currFiles = useRef<S3FileInfo[]>(files);

  async function handleFileSelected(file: File) {
    const response = await getUploadUrl({
      file_name: file.name,
      file_type: file.type,
    });

    const body = new FormData();

    Object.entries(response.fields).forEach(([key, value]) =>
      body.append(key, value)
    );

    body.append("file", file);

    await fetch(response.url, { method: "POST", body });

    currFiles.current = [
      ...currFiles.current,
      { ...fileToFileInfo(file), document: response },
    ];
    setFiles(currFiles.current);
  }

  useEffect(() => {
    currFiles.current = files;
  }, [files]);

  return (
    <FileUpload
      {...fileUploadProps}
      onSelected={handleFileSelected}
      files={files}
      onRemove={(fileToRemove) => {
        setFiles(files.filter((file) => file !== fileToRemove));
      }}
    />
  );
}
